export enum CreditLineRequestCancelReason {
    AccountInactivity = 'Account inactivity',
    UserRequestedToCancel = 'The user requested to cancel',
    creditRequestWasSubmitted = 'A new credit request was submitted',
}
